import React from 'react';
import { View } from 'react-native';

import { useTheme } from '@/components/providers/ThemeProvider';
import { themeScopeVars } from '~/constants/nativewindThemes';

interface ICommunityThemeScopeProps {
  community?: keyof typeof themeScopeVars;
  children: React.ReactNode;
}

/**
 * Renders its subtree in a specific community's branding without touching the
 * global theme (NativeWind vars cascade to descendants). The global theme has
 * a single owner — ThemeProvider's currentCommunity derivation — so preview,
 * auth, and Grokio-meta surfaces scope their branding locally; an imperative
 * global flip here would leak the previewed theme into the signed-in app on
 * OS-gesture exits (iOS swipe back skips screen-level cleanup ordering).
 */
export function CommunityThemeScope({ community, children }: ICommunityThemeScopeProps) {
  const { effectiveColorScheme } = useTheme();
  if (!community || !themeScopeVars[community]) {
    return <>{children}</>;
  }
  return (
    <View style={themeScopeVars[community][effectiveColorScheme]} className="flex-1">
      {children}
    </View>
  );
}
